import { render, staticRenderFns } from "./PdpTabs.vue?vue&type=template&id=2d5c06cc&scoped=true"
import script from "./PdpTabs.vue?vue&type=script&lang=js"
export * from "./PdpTabs.vue?vue&type=script&lang=js"
import style0 from "./PdpTabs.vue?vue&type=style&index=0&id=2d5c06cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c06cc",
  null
  
)

export default component.exports